import { TYPE_BEAD_IMG } from './types'

export class BeadItems {
    x: number
    y: number
    type: number
    pair = 0

    isSuper6 = false
    imgType = TYPE_BEAD_IMG.NONE

    constructor(
        x: number,
        y: number,
        type: number,
        pair = 0,
        isSuper6 = false
    ) {
        this.x = x
        this.y = y
        this.type = type
        this.pair = pair
        this.isSuper6 = isSuper6
    }
}
